import type { AuthUser } from '~redux/auth/actions/authUser';

export const hasUserAgreed = async (authData?: AuthUser) => {
  if (!authData) {
    return false;
  }

  const { attributes } = authData;
  const agreement = attributes['custom:agreement'];
  const agreed = agreement === 'true';

  return agreed;
};
